const Calendar = () => import(/* webpackChunkName: "Calendar" */ "@/views/calendar/Calendar");
const CalendarList = () => import(/* webpackChunkName: "Calendar List" */ "@/views/calendar/CalendarList");

const calendarRoutes = [
  {
    path: "calendar",
    name: "Calendar",
    redirect: {
      name: "Calendar List"
    },
    component: Calendar,
    children: [
      {
        path: "list",
        name: "Calendar List",
        component: CalendarList
      }
      // {
      //   path: "new",
      //   name: "Benefits New",
      //   component: BenefitsNew
      // },
      // {
      //   path: "edit/:id",
      //   name: "Code Edit",
      //   component: CodeEdit,
      //   props: true
      // }
    ]
  }
];

export default calendarRoutes;